// @flow
import styled from 'styled-components';

import colors from '../../assets/css/colors';
import { above } from '../../assets/css/media';

export const PageTitle = styled.h1`
	color: ${colors.title};
	font-size: 15px;
	font-weight: bold;
	line-height: 1.3;

	margin: 20px 10px 12px;

	${above.phone`
		font-size: 20px;
	`}

	${above.tablet`
		font-size: 22px;
		margin: 24px 0 16px;
	`}
`;

export default PageTitle;


// WEBPACK FOOTER //
// ./src/components/PageTitle/index.js